import React, { useContext } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { NoteContext } from '../Contexts/NoteState.js';


function Navbar() {
  let location = useLocation();
  const { setNotes, getData } = useContext(NoteContext);
  let navigate = useNavigate();
  const handlelogout = () => {
    localStorage.removeItem('token');
    setNotes([]);
    navigate('/login');
  }
  return (
    <nav className="navbar navbar-expand-lg bg-body-tertiary">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">iNoteBook</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} aria-current="page" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`} to="/about">About</Link>
            </li>
          </ul>
        </div>
      </div>
      {!localStorage.getItem('token') ? <form className='d-flex'>
        <Link className="btn btn-primary mx-2" to="/login"  role="button">Login</Link>
        <Link className="btn btn-primary mx-2" to="/signup" role="button">Signup</Link>
      </form> : <button className="btn btn-primary mx-2" onClick={handlelogout}>Logout</button>}

    </nav>
  )
}

export default Navbar